import { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  buildCompanyPath,
  getActiveLandingCompanyName,
  getLandingCompanyNameFromPath,
} from "../utils/landingCompany";

export function useCompanyAuthPath() {
  const { pathname } = useLocation();
  const { landingCompanyName } = useParams();

  const fromParam = landingCompanyName
    ? getLandingCompanyNameFromPath(
        `/${decodeURIComponent(landingCompanyName)}`,
      )
    : null;
  const companyName = fromParam || getActiveLandingCompanyName(pathname);

  const companyPath = useCallback(
    (subPath = "") => buildCompanyPath(subPath, companyName),
    [companyName],
  );

  return { companyName, companyPath };
}
